module.exports = __webpack_public_path__ + "resource/img/geo.ff821f83.svg";